import api from './base'

export default {
  save ({ businessUnitId, acceptanceFormId, items }) {
    return api().put(`company/business_units/${businessUnitId}/acceptance_forms/${acceptanceFormId}/articles`, items)
  },
  delete ({ businessUnitId, acceptanceFormId, id }) {
    return api().delete(`company/business_units/${businessUnitId}/acceptance_forms/${acceptanceFormId}/articles/${id}`)
  }
}
